
export const Image = ({ title, largeImage, smallImage }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        <a
          href={largeImage}
          className="glightbox"
          tabIndex={-1}
          aria-label={`Ampliar imagem ${title}`}
        >

          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img
            src={smallImage}
            className="img-fluid"
            alt={title}
            loading="lazy"
          />
        </a>
      </div>
    </div>
  );
};
